<template>
  <div class="p-5 w-full h-full overflow-scroll scrolling-touch">
    <MDArea class="lg:max-w-2xl" :md="require('raw-loader!../MDs/friends.md').default">
    </MDArea>

<!--
    <div class="flex lg:max-w-4xl">
      <PhoneArea :maxWidth="414" class="full mx-2">
        <ThankYouCanvas>
          <ThankYouLayoutSpaceship></ThankYouLayoutSpaceship>
        </ThankYouCanvas>
      </PhoneArea>
      <PhoneArea :maxWidth="414" class="full mx-2">
        <ThankYouCanvas>
          <ThankYouLayoutChurch></ThankYouLayoutChurch>
        </ThankYouCanvas>
      </PhoneArea>
    </div> -->
    <div class="h-64"></div>

    <!--
    <div class="democanvas">
      <ThankYouCanvas></ThankYouCanvas>
    </div>
    -->
    <!--
    <div class="democanvas">
    </div>
    -->

  </div>
</template>

<script>
export default {
  mixins: [
    require('../../Reusable/O3DCompos').O3DCompos
  ],
  mounted () {
  }
}
</script>

<style>
.democanvas{
  width: 100%;
  max-width: 480px;
  height: 480px;
}
</style>
